import { PlantDetailDto, PlantEditDto } from './plant';

export const mapPlantDetailToEdit = (dto: PlantDetailDto): PlantEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  active: dto.active,
  description: dto.description
});
